<template>
  <div :class="{ 'md:max-w-xxs': flexLayout }">
    <button :class="buttonClass" @click="onClick">
      <span
        class="flex justify-center items-center text-center whitespace-normal"
        :class="{ 'md:flex-col': flexLayout }"
      >
        <svg role="presentation" focusable="false" tabindex="-1" v-if="!noIcon"
           
          class="icon icon-md mr-1 text-gray-500"
          :class="{ 'md:flex-1 md:mr-0 md:mb-1': flexLayout }"
          alt=""
          svg-inline
         xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 85 85"><path fill="currentColor" fill-rule="evenodd" d="M69.06 66.4H15.94a2.66 2.66 0 0 1 0-5.3h53.12a2.66 2.66 0 0 1 0 5.3ZM42.5 77.04a2.66 2.66 0 1 1 0-5.32 2.66 2.66 0 0 1 0 5.32Zm-21.25-37.2A21.27 21.27 0 0 1 42.5 18.6a21.27 21.27 0 0 1 21.25 21.25v15.94h-42.5V39.84Zm47.81 15.94V39.84a26.6 26.6 0 0 0-23.9-26.42v-8.1a2.66 2.66 0 1 0-5.32 0v8.1a26.6 26.6 0 0 0-23.9 26.42v15.94a7.98 7.98 0 0 0 0 15.94h19.08a7.8 7.8 0 0 0-.49 2.66 7.98 7.98 0 0 0 15.94 0c0-.94-.2-1.83-.5-2.66h19.1a7.98 7.98 0 0 0 0-15.94Z" clip-rule="evenodd"/></svg>
        <span :class="{ 'md:flex-1': flexLayout }">
          {{ buttonText ?? $t('comparison_alert.track') }}
        </span>
      </span>
    </button>
    <SubscribeModal
      v-if="modalOpen"
      :comparison-id="comparisonId"
      :current-tab="currentTab"
      :signed-in="signedIn"
      :creation-location="creationLocation"
      @close="modalOpen = false"
    />
  </div>
</template>

<script lang="ts" setup>
import SubscribeModal from './subscribe-modal.vue'
import type { AlertCreationLocation } from '@core/types/alerts'
import type { PaymentType } from '@core/types/imt'

defineProps<{
  comparisonId: string
  currentTab: PaymentType
  noIcon?: boolean
  buttonClass?: string | object
  creationLocation: AlertCreationLocation
  flexLayout?: boolean
  buttonText?: string
}>()

const { $cookie, $t } = useNuxtApp()

const modalOpen = ref(false)
const signedIn = ref($cookie.value.getSigned())

function onClick() {
  signedIn.value = $cookie.value.getSigned()
  modalOpen.value = true
}
</script>
